<template>
  <div class="layout-wrapper">
    <v-tabs
      v-model="activeTab"
      background-color="primary"
      dark
    >
      <v-tab
       class="primary--text"
      >Billing
      </v-tab>
      <v-tab
       class="primary--text"
      >
        Pricing
      </v-tab>
      <v-tab
       class="primary--text"
      >
        Subscription
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-row>
          <v-col :md="6">
            <payment-info />
          </v-col>
          <v-col :md="6">
            <invoice />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <pricing-list />
      </v-tab-item>
      <v-tab-item>
        <subscription @onUpgradeClick="handleUpgradeClick" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentInfo from '@/components/Billing/PaymentInfo'
import Invoice from '@/components/Billing/Invoice'

export default {
  name: 'Billing',
  components: {
    'payment-info': PaymentInfo,
    invoice: Invoice,
    'pricing-list': () => import('../components/Billing/PricingList.vue'),
    subscription: () => import('../components/Billing/Subscription.vue')
  },
  computed: {
    ...mapGetters(['user'])
  },
  data () {
    return {
      activeTab: null,
      PricingTab: 1
    }
  },
  methods: {
    handleUpgradeClick () {
      this.activeTab = this.PricingTab
    }
  }
}
</script>

<style scoped>

</style>
